import { Seo } from '../components/Seo';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const About = () => {

  return (
    <>


      <Seo
        title="Schwabe Enterprises - AI Development, Engineering, Consulting, Advanced Data Science, Tech Incubator"
        description="Schwabe Enterprises is a leading provider of AI development, engineering, consulting, advanced data science, and tech incubator services."
        type="webapp"
      />

      <Header selectedNavitem="about" />

      <div className="container py-5">

        {/* Hero Section */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-10">
            <h1 className="display-4 fw-bold mb-4">Global Reach. Precision Execution.</h1>
            <p className="lead text-muted">
              We are a premier consultancy dedicated to helping companies—from agile startups to global enterprises—design and execute world-class SaaS products. With customers spanning the globe, our team brings a wealth of diversity and expertise to every challenge.
            </p>
          </div>
        </div>

        {/* Philosophy Section */}
        <div className="row mb-5 align-items-center">
          <div className="col-lg-12">
            <div className="bg-light p-5 rounded-3 shadow-sm border-start border-primary border-5">
              <h2 className="h3 fw-bold text-dark">The Right Tool for the Job</h2>
              <p className="mb-0 fs-5">
                We are passionate about the newest technology, but we remain grounded in pragmatism. We believe in choosing the <strong>right tool for the job</strong>, not just the trendiest one. Our engineering philosophy balances innovation with reliability, ensuring that the solutions we build are scalable, maintainable, and perfectly suited to your business needs.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <div className="row gy-4 mb-5">
          <div className="col-12 text-center mb-3">
            <h2 className="fw-bold">Our Services</h2>
          </div>

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 border-0 shadow-sm hover-shadow">
              <div className="card-body text-center p-4">
                <div className="mb-3 text-primary">
                  <i className="bi bi-briefcase fs-1"></i> {/* Placeholder icon if bootstrap icons are not loaded, text fallback */}
                  <span className="display-6">💼</span>
                </div>
                <h4 className="card-title fw-bold h5">Consultancy</h4>
                <p className="card-text text-muted small">Strategic guidance to navigate complex technical landscapes and architectural decisions.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 border-0 shadow-sm hover-shadow">
              <div className="card-body text-center p-4">
                <div className="mb-3 text-primary">
                  <span className="display-6">🎓</span>
                </div>
                <h4 className="card-title fw-bold h5">Corporate Training</h4>
                <p className="card-text text-muted small">Professional training programs upskilling teams in the latest development methodologies and tools.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 border-0 shadow-sm hover-shadow">
              <div className="card-body text-center p-4">
                <div className="mb-3 text-primary">
                  <span className="display-6">🛠️</span>
                </div>
                <h4 className="card-title fw-bold h5">Workshops</h4>
                <p className="card-text text-muted small">Hands-on interactive sessions focused on solving specific problems and fostering innovation.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 border-0 shadow-sm hover-shadow">
              <div className="card-body text-center p-4">
                <div className="mb-3 text-primary">
                  <span className="display-6">🚀</span>
                </div>
                <h4 className="card-title fw-bold h5">SaaS Execution</h4>
                <p className="card-text text-muted small">End-to-end design and build services for launching scalable Software as a Service products.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Incubator Teaser */}
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div className="p-5 bg-dark text-white rounded-3 shadow">
              <h2 className="fw-bold mb-3">Innovation Incubator</h2>
              <p className="fs-5 mb-4">
                We are more than just a consultancy. We are an incubator for several promising startup projects looking for the right team to execute and the right partners to invest.
              </p>
              <a href="/incubator" className="btn btn-primary btn-lg px-5 rounded-pill fw-bold">Explore Our Incubator</a>
            </div>
          </div>
        </div>

      </div>

      <Footer />

    </>
  )
};

export default About;